import type {AnchorHTMLAttributes, PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PaginationLink.module.css";

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    isActive?: boolean;
    isDisabled?: boolean;
    size: PaginationSize;
}

type ClassName = keyof typeof styles;

const getLinkSize = (size: PaginationSize) => `paginationLinkSize${capitalize(size)}` as ClassName;

export const PaginationLink = (props: PropsWithChildren<IProps>) => {
    const {className, isActive, isDisabled, size, children, ...anchorProps} = props;

    const classes = cn(
        styles.paginationLink,
        styles[getLinkSize(size)],
        {
            [styles.paginationLinkActive]: isActive,
            [styles.paginationLinkDisabled]: isDisabled
        },
        className
    );

    if (isDisabled) {
        const {
            href: _href,
            rel: _rel,
            target: _target,
            download: _download,
            onClick: _onClick,
            ping: _ping,
            hrefLang: _hrefLang,
            media: _media,
            referrerPolicy: _referrerPolicy,
            ...spanProps
        } = anchorProps;

        return (
            <span className={classes} aria-disabled="true" {...spanProps}>
                {children}
            </span>
        );
    }

    return (
        <a className={classes} {...anchorProps}>
            {children}
        </a>
    );
};
import type {AnchorHTMLAttributes, PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PaginationLink.module.css";

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    isActive?: boolean;
    isDisabled?: boolean;
    size: PaginationSize;
}

type ClassName = keyof typeof styles;

const getLinkSize = (size: PaginationSize) => `paginationLinkSize${capitalize(size)}` as ClassName;

export const PaginationLink = (props: PropsWithChildren<IProps>) => {
    const {className, isActive, isDisabled, size, children, ...anchorProps} = props;

    const classes = cn(
        styles.paginationLink,
        styles[getLinkSize(size)],
        {
            [styles.paginationLinkActive]: isActive,
            [styles.paginationLinkDisabled]: isDisabled
        },
        className
    );

    if (isDisabled) {
        const {
            href: _href,
            rel: _rel,
            target: _target,
            download: _download,
            onClick: _onClick,
            ping: _ping,
            hrefLang: _hrefLang,
            media: _media,
            referrerPolicy: _referrerPolicy,
            ...spanProps
        } = anchorProps;

        return (
            <span className={classes} aria-disabled="true" {...spanProps}>
                {children}
            </span>
        );
    }

    return (
        <a className={classes} {...anchorProps}>
            {children}
        </a>
    );
};
